import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@rdx/store";
import {resetNotification} from "@rdx/slices/Notification";
import {Toast} from "gf-ui-components-mui-lib";


export default function withNotification(Component: React.FunctionComponent){
    function NewComponent(props: any){
        const {
            toastMessage,
            toastType,
            showToast
        } = useSelector((state: RootState) => state.notification);
        const dispatch = useDispatch();
        const clearToast = () => {
            dispatch(resetNotification())
        }
        
        return <>
            <Component {...props}/>
            <Toast 
                {...{ openToast: showToast, 
                message: toastMessage, 
                severity: toastType, 
                setToastData: clearToast,
                sx: {
                    display: showToast ? "block" : "none"
                }
            }}
            /> 
        </>
    }
    return NewComponent;
}